export const OPEN = 'OPEN'
export const RELEASED = 'RELEASED'
export const CLOSED = 'CLOSED'
